import script from "./AEstadoVazioTabela.vue?vue&type=script&setup=true&lang=ts"
export * from "./AEstadoVazioTabela.vue?vue&type=script&setup=true&lang=ts"

import "./AEstadoVazioTabela.vue?vue&type=style&index=0&id=0cd8304c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cd8304c"]])

export default __exports__